<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>
    <div class="card mb-1">
      <div class="card-body p-1">
        <div class="row">
          <div class="col-12 col-md-3">
            <label>Tiêu đề</label>
            <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Tiêu đề bài viết"
              @keyup.enter="updateSearchQuery" />
          </div>
          <div class="col-12 col-md-3">
            <label>Chuyên mục</label>
            <v-select v-model="category_id" :options="all_cats" class="w-100" label="name" :reduce="val => val.id"
              placeholder="--Chọn--" />
          </div>
          <div class="col-12 col-md-3">
            <label>Phòng ban</label>
            <v-select v-model="department_id" :options="dataDepartment" label="name" class="w-100" :reduce="val => val.id"
              placeholder="--Chọn--" />
          </div>
          <div class="col-12 col-md-3">
            <label>Thể loại</label>
            <v-select v-model="article_type_id" :options="dataArticleType" class="w-100" label="name"
              :reduce="val => val.id" placeholder="--Chọn--" />
          </div>
        </div>
        <div class="row mt-1">

          <div class="col-12 col-md-3">
            <b-form-group label="Người tạo" class="author mb-0" label-for="author">
              <v-select v-model="creator" label="full_name_alias" :filterable="false" :options="dataAuthor"
                :reduce="val => val.id" @search="onSearch">
                <template slot="no-options"> Nhập tên tài khoản </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center"> {{ option.full_name_alias }} </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center"> {{ option.full_name_alias }} </div>
                </template>
              </v-select>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Người xuất bản" class="author mb-0" label-for="author">
              <v-select v-model="publisher" label="full_name_alias" :filterable="false" :options="dataPublishor"
                :reduce="val => val.id" @search="onSearchPublishor">
                <template slot="no-options"> Nhập tên tài khoản </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center"> {{ option.full_name_alias }} </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center"> {{ option.full_name_alias }} </div>
                </template>
              </v-select>
            </b-form-group>
            <!-- <label>Người xuất bản</label>
            <b-form-input class="d-inline-block"
              v-model="publisher"
              placeholder="Người xuất bản" /> -->
          </div>
          <div class="col-12 col-md-3">
            <div class="datestart">
              <b-form-group label="Ngày đăng" class="mb-0">
                <date-picker ref="datetime" v-model="loadDateRange" type="datetime" range :shortcuts="shortcuts"
                  :show-time-panel="false" format="DD/MM/YYYY" value-type="format"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy" />
              </b-form-group>
            </div>
            <!-- <b-form-group label="Từ ngày" label-for="start_date">
              <flat-pickr v-model="start_date" class="form-control" :config="config_date" placeholder="dd-mm-yyyy" />
            </b-form-group> -->
          </div>
          <div class="col-12 col-md-3">
            <div style="margin-top: 1.7rem;">
              <b-button variant="primary" @click="updateSearchQuery">
                <feather-icon icon="SearchIcon" /> Tìm kiếm </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <p v-if="$can('article.allow_lock_and_unlock_published', 'Article')">
      <b-button size="sm"
        variant="warning"
        class="font12"
        @click="updateArticleStatus('lock')">Khóa bài viết</b-button>
      <b-button variant="info"
        size="sm"
        class="ml-1 mr-1 font12"
        @click="updateArticleStatus('unlock')">Mở khóa bài viết</b-button>
    </p> -->
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div class="card">
        <div class="m-1">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của {{ dataMeta.of }} mục</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <b-table ref="refListTable" class="table-responsive tableview" :items="itemsData" responsive
          :fields="tableColumns" primary-key="id" show-empty empty-text="Không tìm thấy bản ghi nào">
          <!-- Column: Status -->
          <template v-if="$can('article.allow_lock_and_unlock_published', 'Article')" v-slot:head(id)="data">
            <b-form-checkbox v-model="selectall" variant="outline-secondary" :checked="selectall" @change="checkAll" />
          </template>
          <template #cell(image)="data">
            <img :src="data.item.image" class="img-thumbnail" width="110" />
          </template>
          <template #cell(updated_at)="data">
            <span v-html="data.item.updated_at" />
          </template>
          <template #cell(id)="data">
            <b-form-checkbox v-model="article_ids" :value="data.item.id" variant="outline-secondary" />
          </template>
          <template #cell(title)="data">
            <div class="d-flex flex-column">
              <span class="link text-wrap" style="cursor: pointer;"
                @click="onPreview(data.item.id, data.item.allow_edit ? 'list' : 'show')"><b>{{ data.item.title }}</b>
                <span v-for="(icon, index) in data.item.content_type" :key="index" :class="`icon` + icon" /></span>
              <span class="text1">{{ data.item.category.name }}</span>
              <p v-if="data.item.lock" class="mb-0 text-warning"><span v-html="data.item.lock" />
                <span v-if="data.item.is_lock" class="ml-1 locked" @click="onUnlock(data.item.id)">
                  <font-awesome-icon icon="fa-solid fa-lock" />
                </span>
              </p>
            </div>
          </template>
          <template #cell(history)="data">
            <div class="d-flex flex-column" v-html="data.item.history" />
          </template>
          <template #cell(actions)="data">
            <div v-for="(button, index) in data.item.listButton" :key="index">
              <b-button v-if="button.type == 'link'" size="sm" :variant="button.color" :title="button.title"
                :to="{ name: button.url, params: { id: data.item.id } }">
                <span class="text-nowrap">
                  <feather-icon :icon="button.icon" />
                </span>
              </b-button>
              <b-button v-if="['undo', 'delete'].includes(button.type)" size="sm" :variant="button.color"
                :title="button.title" @click="updateStatus(button.type, data.item)">
                <span class="text-nowrap">
                  <feather-icon :icon="button.icon" />
                </span>
              </b-button>
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của {{ dataMeta.of }} mục</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-overlay>
    <b-modal id="showPreview" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop hide-footer
      title="Xem thử bài viết" @close="hidenModalArticlePreview">
      <article-preview :article_id="article_id" :type_view="type_view" @updateList="handleListData" />
    </b-modal>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BPagination, BInputGroupAppend, BInputGroup, BFormGroup, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { can } from '@core/libs/acl/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useJwt from '@/auth/jwt/useJwt';
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import ArticlePreview from './ArticlePreview.vue'
import axios from '@axios';
import _ from 'lodash';
library.add(faLock);
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    flatPickr,
    BFormGroup,
    BOverlay,
    ArticlePreview,
    FontAwesomeIcon,
    DatePicker
  },
  data() {
    return {
      selectall: false,
      article_ids: [],
      article_id: '',
      type_view: '',
      loadDateRange: '',
    }
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0].replaceAll('/', '-') : ''
      this.end_date = (newDate[1]) ? newDate[1].replaceAll('/', '-') : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const refListTable = ref(null)
    const dataUser = useJwt.getUser();
    const loading = ref(true)

    // Table Handlers
    const tableColumns = [
      { key: 'image', sortable: false, label: 'Ảnh', thAttr: { width: '10%' } },
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      {
        key: 'history', sortable: false, label: 'Tạo - Duyệt - Xuất bản', class: 'history', thAttr: { width: '22%' },
      },
      {
        key: 'unit', sortable: false, label: 'Lấy tin', thAttr: { width: '12%' },
      },
      {
        key: 'updated_at', sortable: false, label: 'Ngày cập nhật', thAttr: { width: '12%' },
      },
      {
        key: 'actions', label: 'Hành động', tdClass: 'action flexitem text-center', thClass: 'action',
      },
    ];
    if (can('article.allow_lock_and_unlock_published', 'Article')) {
      //   tableColumns.unshift({ key: 'id', sortable: false, class: 'itemid' })
    }
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const type = ref('')
    const localSearchQuery = ref('')
    const itemsData = ref([]);
    const all_cats = ref([])
    const dataAuthor = ref([]);
    const dataPublishor = ref([]);
    const dataDepartment = ref([])
    const department_id = ref('')
    const start_date = ref('');
    const end_date = ref('');
    const category_id = ref('')
    const article_type_id = ref('')
    const dataArticleType = ref([])
    const creator = ref('');
    const publisher = ref('');
    const from = ref(0)
    const to = ref(0)
    const fetchAll = (isPaginate) => {

      isPaginate = isPaginate === undefined ? 0 : isPaginate;
      if (!isPaginate) {
        loading.value = true
      }
      store.dispatch('article/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        category_id: category_id.value,
        department_id: department_id.value,
        start_date: start_date.value,
        end_date: end_date.value,
        article_type_id: article_type_id.value,
        card_type: 'published',
        creator: creator.value,
        publisher: publisher.value,
        isPaginate
      })
        .then(response => {
          const result = response.data;
          loading.value = false
          if (result.code === 200) {
            if (isPaginate) {
              from.value = result.data.from;
              to.value = result.data.to;
              total.value = result.data.total;
            } else {

              itemsData.value = result.data.data
              // total.value = result.data.total;
              if (Object.keys(result.data.all_cats).length > 0) {
                all_cats.value = result.data.all_cats;
              }
              dataArticleType.value = result.data.dataArticleType
              setTimeout(() => {
                fetchAll(1);
              }, 1000);
            }
          }
        })
    }
    const dataMeta = computed(() => {
      //const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: from.value,
        to: to.value,
        of: total.value,
      }
    })

    watch([perPage, searchQuery, article_type_id, category_id, department_id, creator, publisher, start_date, end_date], () => {
      currentPage.value = 1
      if (!loading.value) {
        refetchData()
      }
    })
    watch([currentPage], () => {
      if (!loading.value) {
        refetchData()
      }
    })

    const refetchData = () => {
      fetchAll()
    }

    const dataContentType = [
      { label: 'Tin tức', code: 'news' },
      { label: 'Video', code: 'video' },
      { label: 'Autio', code: 'audio' },
      { label: 'Photo', code: 'photo' },
    ]

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false
      }
      fetchAll();
    }

    onMounted(() => {
      fetchAll()
    })
    const fetchDepartment = () => {
      store.dispatch('departments/fetchDepartments', {
        type: 'all',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataDepartment.value = response.data.data;
          }
        })
    }
    fetchDepartment();
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
      { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
      { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] },
    ])
    return {
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      dataContentType,
      article_type_id,
      updateSearchQuery,
      localSearchQuery,
      itemsData,
      dataUser,
      config_date,
      start_date,
      end_date,
      all_cats,
      department_id,
      dataDepartment,
      category_id,
      loading,
      dataArticleType,
      creator,
      publisher,
      dataAuthor,
      dataPublishor,
      from,
      to,
      shortcuts
    }
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false);
  },
  methods: {
    onSearchPublishor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPublishor(loading, search, this);
      }
    },
    searchPublishor: _.debounce((loading, search, vm) => {
      axios.get(`users/search?keyword=${search}`)
        .then((response) => {
          vm.dataPublishor = response.data.data
          loading(false);
        })
    }, 1000),
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      axios.get(`users/search?keyword=${search}`)
        .then((response) => {
          vm.dataAuthor = response.data.data

          loading(false);
        })
    }, 1000),
    onUnlock(id) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn mở khóa bài viết này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const params = { type: 'unlock', ids: { id } }
          store.dispatch('article/lock', params).then(response => {
            const result = response.data;
            if (result.code == 200) {
              this.refetchData();
              showToast(result.message, { variant: 'success' })
            } else {
              showToast(result.message);
            }
          })
        }
      })
    },
    hidenModalArticlePreview() {
      const id = this.article_id
      const params = { type: 'unlock', ids: { id } }
      store.dispatch('article/lock', params).then(response => {
        const result = response.data;
        if (result.code == 200) {
          this.refetchData();
          // showToast(result.message, { variant: 'success' })
        } else {
          // showToast(result.message);
        }
      })
      this.$bvModal.hide('showPreview');
    },
    handleListData(type = false) {
      this.refetchData();
      if (type) {
        this.$bvModal.hide('showPreview')
      }
    },
    onPreview(id, type) {
      // console.log(id, type)
      this.article_id = id;
      this.type_view = type;
      this.$bvModal.show('showPreview');
    },
    checkAll() {
      this.selectall = !!(this.selectall);
      if (this.selectall) {
        for (const item of this.itemsData) {
          if (item.is_lock == false) {
            this.article_ids.push(item.id);
          }
        }
      } else {
        this.article_ids = [];
      }
    },
    updateArticleStatus(type) {
      if (this.article_ids.length > 0) {
        if (type == 'lock' || type == 'unlock') {
          const params = { type, ids: this.article_ids }
          store.dispatch('article/lock', params).then(response => {
            const result = response.data;
            if (result.code == 200) {
              this.refetchData();
              this.article_ids = [];
              showToast(result.message, { variant: 'success' })
            } else {
              showToast(result.message);
            }
          })
        } else {
          this.$swal({
            title: '',
            text: 'Bạn có chắc chắn muốn xóa những bài viết này không?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Có',
            cancelButtonText: 'Không',
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger ml-1',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.isConfirmed) {
              store.dispatch('article/destroy', { ids: this.article_ids }).then(response => {
                const result = response.data;
                if (result.code == 200) {
                  this.refetchData();
                  this.article_ids = [];
                  showToast(result.message, { variant: 'success' })
                } else {
                  showToast(result.message);
                }
              })
            }
          })
        }
      } else {
        let message = 'Chọn ID bài viết cần xóa.';
        if (type == 'lock') {
          message = 'Chọn ID bài viết cần khóa.';
        } else if (type == 'unlock') {
          message = 'Chọn ID bài viết cần mở khóa.';
        }
        showToast(message)
      }
    },
  },
}
</script>

<style lang="scss">
.link {
  color: #000;
  font-weight: bold;

  &:hover {
    color: #e63631
  }
}

@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
